<template lang="pug">
span(ref="mathElement", :style="style")
</template>

<script>
import mathjax from "../mathjax.js";

function childrenTextContent(nodes) {
  return nodes
    ? nodes
        .map((n) => (n.children ? childrenTextContent(n.children) : n.text))
        .join("")
    : "";
}

export default {
  name: "math-jax",
  props: {
    display: { type: Boolean, default: false },
    math: { type: String, default: "" },
    m: { type: String, default: "" },
    tight: { type: [Boolean, Array], default: false },
  },
  data() {
    return { slotContent: "" };
  },
  mounted() {
    this.typesetID = 0;
    this.$watch((vm) => [vm.inline, vm.math], this.typeset.bind(this));
    this.updateSlotContent();
    this.typeset();
  },
  beforeUpdate() {
    this.updateSlotContent();
  },
  computed: {
    latex() {
      return this.math || this.m || this.slotContent;
    },
    style() {
      const style = {
        display: this.display ? "block" : "inline-block",
      };
      if (this.tight) {
        style["overflow"] = "auto";
        if (Array.isArray(this.tight)) {
          style["margin"] = `${-this.tight[0]}px 0 ${-this.tight[1]}px 0`;
        } else {
          style["margin"] = "-12px 0 -12px 0";
        }
      }
      return style;
    },
  },
  watch: {
    latex() {
      this.typeset();
    },
  },
  methods: {
    async typeset() {
      const id = ++this.typesetID;
      const MathJax = await mathjax;
      const newChild = await MathJax.tex2chtmlPromise(this.latex, {
        display: this.display,
      });
      if (id != this.typesetID) return;
      this.$refs.mathElement.replaceChildren(newChild);
      MathJax.startup.document.clear();
      MathJax.startup.document.updateDocument();
    },
    updateSlotContent() {
      this.slotContent = childrenTextContent(this.$slots.default);
    },
  },
};
</script>